import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useEffect, useState } from 'react';
import Info from '../../../../assets/icon/Info_Black.svg?react';
import advertVideo from '../../../../assets/image/MOOD-webinar-2022-banner.mp4';
import { useInitiateConfigQuery } from '../../../../queries/useInitiateConfigQuery';
import useHomeStore from '../../../../store/homeStore';
import { useNotificationStore } from '../../../../store/notificationStore';
import { ENotificationTypes } from '../../../features/Notifications/INotification';
import styles from './AdvertisingBanner.module.scss';

export default function AdvertisingBanner() {
  const { config } = useInitiateConfigQuery();
  const setShowAdvertisingBanner = useHomeStore(
    (state) => state.setShowAdvertisingBanner
  );
  const setAdvertisingBannerButtonText = useHomeStore(
    (state) => state.setAdvertisingBannerButtonText
  );
  const notifications = useNotificationStore((state) => state.notifications);
  const setNotifications = useNotificationStore(
    (state) => state.setNotifications
  );
  const showAdvertisingBanner = useHomeStore(
    (state) => state.showAdvertisingBanner
  );

  const [advertisingBannerText, setAdvertisingBannerText] = useState('');
  const [advertisingBannerTitle, setAdvertisingBannerTitle] = useState('');
  const [advertisingBannerLink_url, setAdvertisingBannerLink_url] =
    useState('');
  const [advertisingBannerLink_text, setAdvertisingBannerLink_text] =
    useState('');
  const [advertisingBannerLink_img, setAdvertisingBannerLink_img] =
    useState('');
  const [advertisingBannerLink_video, setAdvertisingBannerLink_video] =
    useState('');

  const updateNotifications = async (json: {
    showAdvertisingBanner: string;
    advertisingBannerTitle: string;
    advertisingBannerText: string;
    advertisingBannerTextCreatedAt: string;
    advertisingBannerLink_url: string;
    advertisingBannerLink_text: string;
    advertisingBannerLink_img: string;
    advertisingBannerLink_video: string;
  }) => {
    const notification = notifications;
    const date = new Date(json.advertisingBannerTextCreatedAt);
    if (
      !notification.some(
        (x) => x.id === 'news-notification-43c3-91ba-02698dcc98c9'
      ) &&
      localStorage.getItem('showAdvertisingBanner') === 'true'
    ) {
      notification.push({
        // guid id is a random hardcoded id.
        id: 'news-notification-43c3-91ba-02698dcc98c9',
        title: json.advertisingBannerTitle,
        time: isNaN(date.getTime()) ? new Date().getTime() : date.getTime(),
        message: json.advertisingBannerText,
        link: json.advertisingBannerLink_url,
        linkLabel: 'Register here',
        hasLink: true,
        image: json.advertisingBannerLink_img
          ? json.advertisingBannerLink_img
          : '',
        type: ENotificationTypes.NEWS,
      });
      setNotifications(notification);
    }
  };

  const updateBanner = (json: {
    showAdvertisingBanner: string;
    advertisingBannerTitle: string;
    advertisingBannerText: string;
    advertisingBannerTextCreatedAt: string;
    advertisingBannerLink_url: string;
    advertisingBannerLink_text: string;
    advertisingBannerLink_img: string;
    advertisingBannerLink_video: string;
  }) => {
    localStorage.setItem(
      'advertisingBannerTextCreatedAt',
      json.advertisingBannerTextCreatedAt
    );
    localStorage.setItem('showAdvertisingBanner', json.showAdvertisingBanner);

    if (json.showAdvertisingBanner === 'true') {
      setAdvertisingBannerTitle(json.advertisingBannerTitle);
      setAdvertisingBannerText(json.advertisingBannerText);
      setAdvertisingBannerLink_url(json.advertisingBannerLink_url);
      setAdvertisingBannerLink_text(json.advertisingBannerLink_text);
      setAdvertisingBannerLink_img(json.advertisingBannerLink_img);
      setAdvertisingBannerLink_video(json.advertisingBannerLink_video);
      setShowAdvertisingBanner('true');
    }
    if (json.showAdvertisingBanner === 'false') {
      setShowAdvertisingBanner('false');
    }
  };

  useEffect(() => {
    if (config.data) {
      const json = config.data;
      if (json.showAdvertisingBanner === 'true') {
        updateNotifications(json);
        if (
          localStorage.getItem('advertisingBannerTextCreatedAt') === null ||
          localStorage.getItem('showAdvertisingBanner') === null
        ) {
          return updateBanner(json);
        }
        if (
          localStorage.getItem('advertisingBannerTextCreatedAt') !==
          json.advertisingBannerTextCreatedAt
        ) {
          return updateBanner(json);
        }
        if (
          localStorage.getItem('advertisingBannerTextCreatedAt') ===
          json.advertisingBannerTextCreatedAt
        ) {
          if (localStorage.getItem('showAdvertisingBanner') === 'false') {
            localStorage.setItem('showAdvertisingBanner', 'true');
          }
          setAdvertisingBannerTitle(json.advertisingBannerTitle);
          setAdvertisingBannerText(json.advertisingBannerText);
          setAdvertisingBannerLink_url(json.advertisingBannerLink_url);
          setAdvertisingBannerLink_text(json.advertisingBannerLink_text);
          setAdvertisingBannerLink_img(json.advertisingBannerLink_img);
          setAdvertisingBannerLink_video(json.advertisingBannerLink_video);
          setAdvertisingBannerButtonText(json.advertisingBannerButton_text);
          setShowAdvertisingBanner('true');
        }
      }
      if (json.showAdvertisingBanner === 'false') {
        localStorage.setItem('showAdvertisingBanner', 'false');
      }
    }
  }, [config.data]);

  const dismissBanner = () => {
    setShowAdvertisingBanner('false');
  };

  return showAdvertisingBanner === 'true' ? (
    <div className={styles.root}>
      <CloseOutlined className={styles.closeIcon} onClick={dismissBanner} />
      <div className={styles.titleContainer}>
        <div className={styles.icon}>
          <Info />
        </div>
        <div className={styles.message}>
          <div className={styles.title}>{advertisingBannerTitle}</div>
          <div className={styles.text}>{advertisingBannerText}</div>

          <a
            href={advertisingBannerLink_url}
            target='_blank'
            rel='noreferrer'
            className={styles.text}
          >
            {advertisingBannerLink_text ?? 'Click here'}
          </a>
        </div>
      </div>
      {/* {(advertisingBannerLink_img || advertisingBannerLink_video) && ( */}
      <a href={advertisingBannerLink_url} target='_blank' rel='noreferrer'>
        <div className={styles.image}>
          {advertisingBannerLink_video && (
            <video
              src={advertisingBannerLink_video}
              loop
              autoPlay
              muted
            ></video>
          )}
          {advertisingBannerLink_img && !advertisingBannerLink_video && (
            <img src={advertisingBannerLink_img} alt='' />
          )}

          {!advertisingBannerLink_img && !advertisingBannerLink_video && (
            <video src={advertVideo} loop autoPlay muted></video>
          )}
        </div>
      </a>
      {/* )} */}
      <div className={styles.closeBtnRow}>
        <Button onClick={dismissBanner}>Close</Button>
      </div>
    </div>
  ) : null;
}
